import type { WizardFarm } from '../../types/farmWizard'
import { useT } from '../../i18n'

// Strategy doc §11's error-prevention table calls for "confirmación visual
// del contexto seleccionado antes de guardar" -- visual confirmation of the
// selected context before saving. This is that: rendered on every Crew Mode
// screen (the launcher and all four capture screens), right after
// OperatorGate, so the farm is visible continuously, not just at one early
// step. The dropdown (the "si aplica más de una" part of §9's flow) only
// appears when there's more than one farm to choose from; with exactly one,
// this is a plain read-only label.

export type CrewModeFarmBarProps = {
  farmId: string
  farms: WizardFarm[]
  onSelectFarm: (farmId: string) => void
}

export default function CrewModeFarmBar({ farmId, farms, onSelectFarm }: CrewModeFarmBarProps) {
  const t = useT()

  if (farms.length === 0) return null

  const selectedFarm = farms.find((farm) => String(farm.id) === farmId)

  return (
    <div
      data-testid="crew-mode-farm-bar"
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 10,
        padding: '10px 12px',
        borderRadius: 10,
        backgroundColor: '#eff6ff',
        border: '1px solid #bfdbfe'
      }}
    >
      <span style={{ fontSize: 13, fontWeight: 700, color: '#1e3a8a' }}>
        {t('crewMode.farmBar.label')}: {selectedFarm?.name ?? '—'}
      </span>
      {farms.length > 1 && (
        <select
          data-testid="crew-mode-farm-select"
          value={farmId}
          onChange={(event) => onSelectFarm(event.target.value)}
          aria-label={t('crewMode.farmBar.changeLabel')}
          style={{
            minHeight: 44,
            padding: '6px 10px',
            borderRadius: 8,
            border: '1px solid #93c5fd',
            fontSize: 14,
            fontWeight: 700
          }}
        >
          {farms.map((farm) => (
            <option key={String(farm.id)} value={String(farm.id)}>
              {farm.name}
            </option>
          ))}
        </select>
      )}
    </div>
  )
}
